module.exports = __webpack_public_path__ + "media/images/file-icons/64/002-tool-d9fe4d48c2cc0c7c4873ff1df8ffbb24.png";